import {
  ApolloClient,
  NormalizedCacheObject,
  useLazyQuery,
  useMutation
} from '@apollo/client';
import {
  MigratePortfolioModel,
  MigratePortfolioVars,
  UserPortfolioModel,
  UserPortfolioVars
} from '../models';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../../dashboard/gql';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

export function useUserPortfolio() {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const [
    _userPortfolio,
    {
      loading: userPortfolioLoading,
      error: userPortfolioError,
      data: userPortfolioData
    }
  ] = useLazyQuery<UserPortfolioModel, UserPortfolioVars>(
    GraphQL.Query.USER_MODULE_PORTFOLIO,
    {
      client: dashboardApolloClient,
      fetchPolicy: 'cache-and-network'
    }
  );

  function getUserPortfolio(userkey: number, modulekey: number) {
    _userPortfolio({
      variables: {
        userkey,
        modulekey
      }
    });
  }

  const [
    _migratePortfolio,
    { loading: migrating, error: migrateError, data: migrateData }
  ] = useMutation<MigratePortfolioModel, MigratePortfolioVars>(
    GraphQL.Mutation.MIGRATE_PORTFOLIO,
    {
      client: dashboardApolloClient
    }
  );

  const migratePortfolio = async (
    userkey: number,
    coursekey: number,
    modulekey: number,
    lessonVersion: number,
    layer: number
  ): Promise<MigratePortfolioModel> => {
    const result = await _migratePortfolio({
      variables: {
        userkey,
        coursekey,
        modulekey,
        lessonVersion,
        layer
      }
    });
    return result?.data;
  };

  return {
    migratePortfolio,
    getUserPortfolio,
    userPortfolioLoading,
    userPortfolioError,
    userPortfolioData,
    migrating,
    migrateData,
    migrateError
  };
}
